import { render, staticRenderFns } from "./PayrollSite.vue?vue&type=template&id=8d421dcc&scoped=true"
import script from "./PayrollSite.vue?vue&type=script&lang=js"
export * from "./PayrollSite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d421dcc",
  null
  
)

export default component.exports